import { ApiClient } from '@monecolier/api-client';

export const apiClient = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
});
